import CreateOrganizationContent from "../../content/organization/createOrganization";
import { Layout } from "../../layout/page";

export function CreateOrganization() {
  return (
    <Layout>
      <CreateOrganizationContent />
    </Layout>
  );
}
